
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

export const ADD_QUOTE_CAPTURE = '[QUOTE_CAPTURE] Add';
export const REMOVE_QUOTE_CAPTURE = '[QUOTE_CAPTURE] Remove';

// AddPersonalDetails
export class AddQuoteCapture implements Action {
    readonly type = ADD_QUOTE_CAPTURE;

    constructor(public payload) { }
}
// RemovePersonalDetails
export class RemoveQuoteCapture implements Action {
    readonly type = REMOVE_QUOTE_CAPTURE;

    constructor(public payload: number) { }
}

export type Actions = AddQuoteCapture | RemoveQuoteCapture;
